import { useQuery } from 'react-query';
import { network } from 'services/network';
import { QueryKeys } from 'api/queryKeys';

const queryFn = () => {
    return network.get('api/bo/getTagsAssignedToCurrentCustomerSubPrograms').then((response) => {
        return response.data;
    });
};

export const useQueryGetTagsAssignedToCurrentCustomerSubPrograms = () => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys]>({
        queryKey: ['getTagsAssignedToCurrentCustomerSubPrograms'],
        queryFn: () => queryFn(),
    });
};

interface QueryResponse {
    id: number;
    name: string;
}
